import { render } from "./GraficoMultiplesFaenasDiaO2NaturalOxigenado.vue?vue&type=template&id=7b9c124e"
import script from "./GraficoMultiplesFaenasDiaO2NaturalOxigenado.vue?vue&type=script&lang=js"
export * from "./GraficoMultiplesFaenasDiaO2NaturalOxigenado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__